import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0172f8ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Uploading...", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Transcribing..."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("*It takes around 1-2 mins...")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Uploaded file must be audio file and less than 25MB.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      width: "800",
      variant: "outlined",
      class: "mx-auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createTextVNode("Upload Your Lesson Data")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_subtitle, null, {
              default: _withCtx(() => [
                _createTextVNode("Lesson Date")
              ]),
              _: 1
            }),
            _createVNode(_component_v_menu, {
              modelValue: _ctx.menu,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.menu) = $event)),
              "close-on-content-click": false,
              "nudge-right": 40,
              transition: "scale-transition",
              "offset-y": "",
              "min-width": "auto"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_text_field, _mergeProps({
                  modelValue: _ctx.formattedDate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formattedDate) = $event)),
                  label: "Select Date",
                  "prepend-icon": "mdi-calendar",
                  readonly: ""
                }, props), null, 16, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_date_picker, {
                  modelValue: _ctx.selectedDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event)),
                  "no-title": "",
                  scrollable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_subtitle, null, {
              default: _withCtx(() => [
                _createTextVNode("Recorded Data")
              ]),
              _: 1
            }),
            _createVNode(_component_v_file_input, {
              modelValue: _ctx.audioFile,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.audioFile) = $event)),
              accept: "audio/*",
              placeholder: "Pick an audio file",
              "prepend-icon": "mdi-music",
              label: "Audio File"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_subtitle, null, {
              default: _withCtx(() => [
                _createTextVNode("Note")
              ]),
              _: 1
            }),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.note,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.note) = $event)),
              label: "Note",
              "hide-details": "auto",
              "prepend-icon": "mdi-pencil"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _ctx.uploadFile,
              text: "Upload",
              flat: ""
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.uploading,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.uploading) = $event)),
      persistent: "",
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, { class: "text-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  size: "64"
                }),
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.uploadComplete,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.uploadComplete) = $event)),
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text=h5" }, {
              default: _withCtx(() => [
                _createTextVNode("Upload Complete")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Your audio file has been uploaded successfully! ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _ctx.executeTranscribe
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Transcribe")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.processing,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.processing) = $event)),
      persistent: "",
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, { class: "text-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  size: "64"
                }),
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.processingComplete,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.processingComplete) = $event)),
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h5" }, {
              default: _withCtx(() => [
                _createTextVNode("Processing Complete")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Your lesson has been transcribed successfully! ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.processingComplete = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OK")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isCancel,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isCancel) = $event)),
      persistent: "",
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, { class: "text-center" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isCancel = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OK")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.processingFailed,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.processingFailed) = $event)),
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h5" }, {
              default: _withCtx(() => [
                _createTextVNode("Proccesing Failed.")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Sorry, we couldn't process your request. "),
                _hoisted_4,
                _createTextVNode("Please try again later. ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.processingFailed = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OK")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.exceededUploadNum,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.exceededUploadNum) = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h5" }, {
              default: _withCtx(() => [
                _createTextVNode("Exceeded Upload Times")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" You are allowed to upload the file three times per day. ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.exceededUploadNum = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OK")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}